<template>
  <section class="rounded-lg border bg-card p-6">
    <h3 class="text-base font-medium">
      Template Actions
    </h3>
    <p class="mt-2 text-sm text-muted-foreground">
      Manage default values used when this template generates tasks.
    </p>
    <div class="mt-4 flex flex-wrap items-center gap-4">
      <TaskTemplatePriorityField
        :task-template="taskTemplate"
        :value="taskTemplate.priority"
        :context="context"
        show-label
      />
      <TaskTemplateDefaultDeadlineField
        :task-template="taskTemplate"
        :value="taskTemplate.default_deadline_after_minutes"
        :context="context"
        show-label
      />
      <TaskTemplateAssigneeField
        :task-template="taskTemplate"
        :value="taskTemplate.assigned_to_user_id"
        :context="context"
        show-label
      />
      <TaskTemplateTitleEditField
        :task-template="taskTemplate"
        :value="taskTemplate.title"
        :context="context"
        show-label
      />
      <TaskTemplateDescriptionField
        :task-template="taskTemplate"
        :value="taskTemplate.description"
        :context="context"
        show-label
      />
      <TaskTemplateLaunchField
        :task-template="taskTemplate"
        :context="context"
        @launched="onLaunched"
      />
    </div>
  </section>
</template>

<script setup>
import TaskTemplateLaunchField from './fields/TaskTemplateLaunchField.vue'
import TaskTemplateAssigneeField from './fields/TaskTemplateAssigneeField.vue'
import TaskTemplateDefaultDeadlineField from './fields/TaskTemplateDefaultDeadlineField.vue'
import TaskTemplateDescriptionField from './fields/TaskTemplateDescriptionField.vue'
import TaskTemplatePriorityField from './fields/TaskTemplatePriorityField.vue'
import TaskTemplateTitleEditField from './fields/TaskTemplateTitleEditField.vue'

const emit = defineEmits(['launched'])

defineProps({
  taskTemplate: {
    type: Object,
    required: true,
  },
  context: {
    type: String,
    default: 'task-template-show',
  },
})

const onLaunched = (task) => {
  emit('launched', task)
}
</script>
